<template>
  <el-dialog title="修改密码" width="400px" :visible="showDialog" :close-on-click-modal="false" @close="onClose">
    <div class="popup" ref="bindDevice">
      <div class="content global-map-dialog">
        <el-form :model="info" ref="form" :rules="rules" label-width="80px" label-position="left">
          <div class="phone_div">
            <span>手机号码</span>
            <span class="phone">{{userInfo.mobile || '无号码'}}</span>
          </div>
          <el-form-item label="图形验证" prop="verifyCode">
            <el-input v-model="info.verifyCode" placeholder='请输入图形验证码' style="width: 204px !important;"></el-input>
            <img v-if="verifyCode" class="verifyCode" :src="verifyCode" width="70px" height="31px" @click="getVerifyCode">
          </el-form-item>
          <el-form-item label="短信验证" prop="verifySmsCode">
            <el-input v-model="info.verifySmsCode" type="text" placeholder='请输入短信验证码' autocomplete="off"></el-input>
            <div class="code">
              <div v-if="!sendCode" @click="getCode">获取验证码</div>
              <div style="color: #99999;" v-else>({{seconds}}秒)</div>
            </div>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input v-model="info.password" type="password" placeholder='请输入新密码(6-12位数字+字母)' auto-complete="new-password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input v-model="info.confirmPassword" type="password" placeholder='请再次确认新密码(6-12位数字+字母)'></el-input>
          </el-form-item>
        </el-form>
        <div class="global-button-Section">
          <div class="button" @click="onSubmit">确定</div>
          <div class="button light" @click="onClose">取消</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { password1 } from '@/utils/validate'
export default {
  name: 'DeviceMap',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.info.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      info: {
        verifyCode: '',
        verifySmsCode: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        verifyCode: [{ required: true, message: '请输入图形验证码', trigger: ['blur', 'change'] }],
        verifySmsCode: [{ required: true, message: '请输入短信验证码', trigger: ['blur', 'change'] }],
        password: [{ required: true, message: '请输入新密码', trigger: ['blur', 'change'] },
          { validator: password1, trigger: ['blur', 'change'] }],
        confirmPassword: [{ required: true, message: '请请再次确认新密码', trigger: ['blur', 'change'] },
          { validator: validatePass, trigger: ['blur', 'change'] }]
      },
      sendCode: false,
      seconds: 60,
      verifyCode: ''
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },
  watch: {
    $route () {
      this.onClose()
      this._interval && clearInterval(this._interval)
    },
    showDialog (val) {
      val && this.getVerifyCode()
    }
  },
  created () {
  },
  destroyed () {
  },
  methods: {
    getCode () {
      if (!this.userInfo.mobile) {
        this.$message('该用户无手机号！')
        return false
      }
      if (!this.info.verifyCode) {
        this.$message('请先输入图形验证码')
        return false
      }
      this.getPhoneCode()
    },
    getPhoneCode () {
      this.$axios.post(this.$apis.common.sendSms, {
        mobile: this.userInfo.mobile,
        verifyCode: this.info.verifyCode
      }).then(res => {
        this.$message.success('请稍等，正在发送中...')
        // 获取验证码
        this.sendCode = true
        this._interval = setInterval(() => {
          if (this.seconds === 1) {
            this._interval && clearInterval(this._interval)
            this.sendCode = false
          }
          this.seconds--
        }, 1000)
      })
    },
    // 图形验证码
    getVerifyCode () {
      this.$axios.get(this.$apis.common.getVerifyCodeIn, '', { responseType: 'blob' }).then(res => {
        this.verifyCode = res
      })
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$axios.post(this.$apis.common.updateInitPassword, {
            verifySmsCode: this.info.verifySmsCode,
            newPassword: this.info.password
          }).then(res => {
            this.$message.success('修改成功')
            this.onClose()
          })
        }
      })
    },
    onClose () {
      this.$emit('closeDialog')
      this.info = {
        verifyCode: '',
        verifySmsCode: '',
        password: '',
        confirmPassword: ''
      }
      this._interval && clearInterval(this._interval)
      this.seconds = 60
      this.sendCode = false
    }
  }
}
</script>

<style scoped lang='scss'>
.popup{
  font-family: PingFang SC;
  font-weight: 400;
  background: var(--map-popup-bg);
  border-radius: 10px;
  font-size: 14px;
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 34px;
    background: #2E3C55;
    padding: 10px 19px;
    color: #FFFFFF;
    border-radius: 10px 10px 0 0;
  }
  .content{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 290px;
    color: var(--header-bar-title-color);
    padding: 25px 20px 30px 20px;
    font-size: 14px !important;
    ::v-deep {
      .el-input {
        font-size: 14px !important;
        width: 260px !important;
      }
      .el-form-item__label{
        font-size: 14px !important;
      }
    }
  }
 }

 .phone_div{
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  .phone{
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: var(--update-password-phone);
    margin-left: 30px;
  }
 }
 ::v-deep .el-input{
  position: relative;
 }

 .code{
    position: absolute;
    right: 11px;
    top: 3px;
    color: #1B85FF;
    cursor: pointer;
  }
  .verifyCode{
    position: absolute;
    right: 0;
    cursor: pointer;
  }
</style>
